<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <path d="m16.474 15.35-.675-9.75a1.18 1.18 0 0 0-1.174-1.1h-1.313a.188.188 0 0 1-.187-.188v-.187a4.125 4.125 0 0 0-8.25 0v.188a.187.187 0 0 1-.188.187H3.375A1.18 1.18 0 0 0 2.2 5.597l-.675 9.75c-.017.26-.025.52-.025.778A1.875 1.875 0 0 0 3.375 18h11.25a1.875 1.875 0 0 0 1.875-1.875c0-.258-.009-.517-.026-.775ZM6.375 4.125a2.625 2.625 0 0 1 5.25 0v.188a.188.188 0 0 1-.188.187H6.564a.187.187 0 0 1-.188-.188v-.187Z"
          fill="currentColor"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'ShoppingBag',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>